// API service layer (static now, backend-ready later)
//
// Future plan:
// - Add a .NET API (e.g., https://api.yoursite.com)
// - Create endpoints:
//   POST /contact
//   POST /payments/create-intent
// - Update baseUrl and remove the simulated responses below

export const api = {
  baseUrl: '',

  async submitContact(payload) {
    // FormSubmit endpoint to deliver inquiries directly to inbox.
    const data = {
      name: payload?.name || '',
      email: payload?.email || '',
      message: payload?.message || '',
      _subject: 'New Contact Us inquiry from FuseIo website',
      _captcha: 'false',
      _template: 'table',
    };

    const res = await fetch('https://formsubmit.co/ajax/Info@fuseio.co', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      throw new Error(`Contact form submission failed (${res.status})`);
    }

    return { ok: true };
  },

  async createPaymentIntent({ packageKey }) {
    // Placeholder for Stripe PaymentIntent creation.
    // Backend later:
    // POST `${api.baseUrl}/payments/create-intent` with { packageKey }
    // return { clientSecret }

    await new Promise((r) => setTimeout(r, 450));
    return { clientSecret: 'pi_placeholder_secret' };
  },
};
